export const VVIC_DATA_SOURCE = "-vvic";
export const CCCI_DATA_SOURCE = "-ccci"; // Chlorophyll 
export const TOANDRE_DATA_SOURCE = "-toandre"; 
export const BI_DATA_SOURCE =  "-bi";
export const CLAY_DATA_SOURCE =  "-clay";
export const S__SALTS_DATA_SOURCE =  "-s__salts";
export const QT_DATA_SOURCE =  "-qt";
export const KSAT_DATA_SOURCE =  "-ksat";
export const PAWC_DATA_SOURCE =  "-pawc";
export const PGI_DATA_SOURCE = "-pgi";
export const NAIP_DATA_SOURCE = "\"naip\"";
export const ESRI_DATA_SOURCE = "ESRI";
export const MAPBOX_DATA_SOURCE = "MAPBOX";
export const ESRI_DATA_SOURCE_LABELS = "ESRI_LABELS";
export const HIGH_RES_BI = "-bi";
export const HIGH_RES_COLOR_IR = "-rgbn"; // same ID!!
export const HIGH_RES_COLOR = "-rgbn"; // same ID!!  
export const HIGH_RES_PGI = "-pgi"; 
export const HIGH_RES_THERMAL_IR = "-tir"; 
export const HIGH_RES_VVI = "-vvi"; 
//////////////////////////////
// EXCLUDE FROM L2 DVS IMAGERY
//////////////////////////////
export const HIGH_RES_TWI = "-twi" // Topographic Wetness Index
export const HIGH_RES_SLOPE = "-slope" // Slope
export const HIGH_RES_PROFILECURVATURE = "-profilecurvature" // Profile Curvature
export const HIGH_RES_PLANIMETRICCURVATURE = "-planimetriccurvature" // Planimetric Curvature
export const HIGH_RES_ELEVATION = "-dtm" // Elevation
export const HIGH_RES_ASPECT = "-aspect" // Aspect